
/* injects from baggage-loader */

import React from "react";
import Zergling from "../../../helpers/zergling";
import { BETSLIP_ADDS } from "../../../actions/actionTypes";
import Loader from "../loader";

export default class BetCoLacky extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectionList: [],
			loading: false,
		};
	}
	convertTreeToItems(tree) {
		//TO DO
		const data = [];
		const sports = Object.keys(tree.sport).filter(item =>
			Object.prototype.hasOwnProperty.call(tree.sport, item)
		);

		sports.map(sport => {
			const regionTree = tree.sport[sport].region;
			const regions = Object.keys(regionTree).filter(item =>
				Object.prototype.hasOwnProperty.call(regionTree, item)
			);

			regions.map(region => {
				const competitionTree = regionTree[region].competition;
				const competitions = Object.keys(competitionTree).filter(item =>
					Object.prototype.hasOwnProperty.call(competitionTree, item)
				);

				competitions.map(competition => {
					const gameTree = competitionTree[competition].game;
					const games = Object.keys(gameTree).filter(item =>
						Object.prototype.hasOwnProperty.call(gameTree, item)
					);

					games.map(game => {
						const marketTree = gameTree[game].market;
						const markets = Object.keys(marketTree).filter(item =>
							Object.prototype.hasOwnProperty.call(marketTree, item)
						);

						markets.map(market => {
							const eventTree = marketTree[market].event;
							const events = Object.keys(eventTree).filter(item =>
								Object.prototype.hasOwnProperty.call(eventTree, item)
							);

							events.map(event => {
								data.push({
									sportName: tree.sport[sport].name,
									regionName: regionTree[region].name,
									competitionName:
										competitionTree[competition].name,
									gameId: gameTree[game].id,
									start: gameTree[game].start_ts,
									team1_name: gameTree[game].team1_name,
									team2_name: gameTree[game].team2_name,
									eventId: eventTree[event].id,
									eventType: eventTree[event].type,
									...eventTree[event],
									initialPrice: eventTree[event].price,
									initialBase: eventTree[event].base,
									title:
										gameTree[game].team1_name +
										" - " +
										gameTree[game].team2_name,
									marketType: marketTree[market].market_type,
									marketName: marketTree[market].name,
									marketDisplayKey:
										marketTree[market].display_key,

									isLive: false,
									conflicts: [],
									singleStake: "",
									singleUnitStake: "",
									incInSysCalc: true,
									processing: false,
									eachWay: false,
									ewAllowed: false,
									oddType: null,
									pick: eventTree[event].type,
								});
							});
						});
					});
				});
			});
		});
		return data;
	}
	getBetCoLuckyList() {
		const command = selections => ({
			source: "betting",
			what: {
				sport: ["name", "alias"],
				region: ["name"],
				game: [],
				market: [],
				competition: ["name"],
				event: ["id", "order", "name", "price", "type", "base"],
			},
			where: { event: { id: { "@in": selections } } },
		});
		return async () => {
			this.setState({ loading: true });
			const response = await fetch("https://varys.betconstruct.com/api/v3/recommendations/client/1");
			const data = (await response.json()).data;
			const selections = data[Math.floor(Math.random() * data.length)].selections;
			const fullselectionsTree = (await Zergling.get(command(selections))).data;
			const dataList = this.convertTreeToItems(fullselectionsTree);
			this.setState({ selectionList: dataList, loading: false });
		};
	}
	moveToBetSlip() {
		return () => {
			this.props.dispatch({
				type: BETSLIP_ADDS,
				payload: this.state.selectionList,
			});
			this.props.toggleToBetSlip();
			this.setState({ selectionList: [] });
		};
	}
	render() {
		// console.log(this.state.selectionList);
		if (this.state.loading) {
			return (
				<div ref={this.props.deepRef} className="lucky-bet-block">
					<Loader component="betCoLacky" />
				</div>
			);
		} else if (this.state.selectionList.length === 0) {
			return (
				<div ref={this.props.deepRef} className="lucky-bet-block">
					<div> </div>
					<div className="text-info-b">
						<span>Borussia Dortmund</span>
						<span>Bayern Munich</span>
						<span>Real Madrid CF</span>
						<span>Juventus FC</span>
						<span>U.S. Sassuolo Calcio</span>
						<span>AC Milan</span>
						<span>SSC Napoli</span>
						<span>SSC Napoli</span>
						<span>Borussia Monchengladbach</span>
					</div>
					<div className="text-info-b">
						<span>Borussia Dortmund</span>
						<span>Bayern Munich</span>
						<span>Real Madrid CF</span>
						<span>Juventus FC</span>
						<span>U.S. Sassuolo Calcio</span>
						<span>AC Milan</span>
						<span>SSC Napoli</span>
						<span>SSC Napoli</span>
						<span>Borussia Monchengladbach</span>
					</div>

					<div className="b-v-w-ice">
						<button
							onClick={this.getBetCoLuckyList()}
							className="button-view-normal-m gradient-v"
						>
							Lucky Bet
						</button>
					</div>
				</div>
			);
		}
		return (
			<div ref={this.props.deepRef} className="lucky-bet-block">
				{this.state.selectionList.map(selection => (
					<div class="lucky-event-list single-event-contain-m">
						<div class="team-name-view-b-m">
							<b>{selection.title}</b>
							{/* <button class="event-remove-b-m"></button> */}
						</div>
						<div class="market-full-info-m">
							<ul>
								<li>
									<p class="betmarket-name-m">
										{selection.marketName}
									</p>
								</li>
							</ul>
							<ul>
								<li>
									<p class="bet-pick-name-m">{`${
										selection.pick
									} ${selection.base || ""}`}</p>
								</li>
								<li>
									<span class="price-view-m">
										{selection.initialPrice}
									</span>
								</li>
							</ul>
						</div>
						<div class="single-bet-m"></div>
					</div>
				))}
				<div className="b-v-w-ice">
					<button
						onClick={this.getBetCoLuckyList()}
						className="button-view-normal-m gradient-v"
					>
						Retry Lucky Bet
					</button>
				</div>
				<div className="b-v-w-ice">
					<button
						onClick={this.moveToBetSlip()}
						className="button-view-normal-m gradient-v"
					>
						Move to betslip
					</button>
				</div>
			</div>
		);
	}
}
